import type { UserBase } from 'models';
import { Card, Form } from 'ui';
import { MemberOrganizationsList } from './member-organizations-list';
import {
  MemberOrganizationsListFilter,
  type MemberOrganizationsListFiltersFormValues,
} from './member-organizations-list-filter';

type FormValues = MemberOrganizationsListFiltersFormValues;

type P = { getPathToOrganizationDetail: (id: string) => string; member: UserBase };

const MemberOrganizations = ({ getPathToOrganizationDetail, member }: P) => (
  <Card>
    <Form<FormValues> noOptional>
      <MemberOrganizationsListFilter />
      <Form.Item<FormValues> dependencies={['search']} noStyle>
        {({ getFieldsValue }) => {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
          const { search } = getFieldsValue(true) as FormValues;

          return (
            <MemberOrganizationsList
              getPathToOrganizationDetail={getPathToOrganizationDetail}
              memberId={member.id}
              search={search}
            />
          );
        }}
      </Form.Item>
    </Form>
  </Card>
);

export default MemberOrganizations;
